import { useContext, useMemo } from 'react';
import { Card } from '@usealloy/component-library';
import { DecisionTypesMap } from '@usealloy/typegen';

import JourneyApplicationContext from '~/application-review/context';
import { UserContext } from '~/dashboard/context';
import WatchlistReview from '~/entities/evaluations/watchlist-review/WatchlistReview';

import { hasWatchlistServiceConfigured } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { useEventTypeEvaluationsContext } from '../context';

const WatchlistMatches = () => {
  const { featureFlags } = useContext(UserContext);
  const { evaluation, isInvestigationPage } = useEventTypeEvaluationsContext();
  const { isAlertInTerminalState, currentAgentIsAssigned } = useContext(JourneyApplicationContext);
  const hideEmptyCardsEnabled = Boolean(featureFlags?.removeEmptyCards);

  const canAgentResolve = useMemo(() => {
    if (isInvestigationPage && isAlertInTerminalState) return false;
    if (evaluation.decision_type === DecisionTypesMap.INFORMATIONAL) return false;
    return currentAgentIsAssigned;
  }, [
    currentAgentIsAssigned,
    evaluation.decision_type,
    isInvestigationPage,
    isAlertInTerminalState,
  ]);

  // Don't render if feature flag is ON and no watchlist service configured
  // WatchlistReview handles empty state internally
  if (!shouldRenderCard(hasWatchlistServiceConfigured(evaluation), hideEmptyCardsEnabled)) {
    return null;
  }

  return (
    <Card
      header="Watchlist Matches"
      collapsible
      contentGap={0}
    >
      <WatchlistReview
        canAgentResolve={canAgentResolve}
        entityToken={evaluation.entity_token}
        evaluationToken={evaluation.evaluation_token}
        showLatestDecisions
      />
    </Card>
  );
};

export default WatchlistMatches;
